import { UserInfo } from '@core/models/interfaces/auth';
import { createReducer, on } from '@ngrx/store';
import {
  login,
  loginFailed,
  loginSuccess,
  logout,
  otpRequired,
  register,
  registerFailed,
  registerSuccess,
  setAuthState,
  setBusinessIdSelected,
  setBusinessNameSelected,
  setFacebookAccounts,
  setFacebookAccountSelected,
  updateUserInfoField,
  verifyOtp,
  verifyOtpFailed,
  verifyOtpSuccess
} from './auth.actions';
import { FacebookAccount } from '@core/models/interfaces/facebook/facebook-account';

export interface AuthState {
  accessToken: string;
  error: string;
  isLogging: boolean;
  isRegistering: boolean;
  isLoggedIn: boolean;
  otpRequired: boolean;
  userInfo?: UserInfo;
  facebookAccounts: FacebookAccount[];
  businessIdSelected: string;
  businessNameSelected: string;
  facebookAccountSelected?: FacebookAccount;
}

const initialState: AuthState = {
  accessToken: '',
  error: '',
  userInfo: undefined,
  isLogging: false,
  isRegistering: false,
  isLoggedIn: false,
  otpRequired: false,
  facebookAccounts: [],
  facebookAccountSelected: undefined,
  businessIdSelected: '',
  businessNameSelected: ''
};

export const authReducer = createReducer(
  initialState,
  on(login, state => ({
    ...state,
    error: '',
    isLogging: true
  })),

  on(loginSuccess, (state, { accessToken, userInfo }) => ({
    ...state,
    accessToken,
    userInfo,
    isLogging: false,
    isLoggedIn: true
  })),

  on(loginFailed, (state, { error }) => ({
    ...state,
    error,
    isLogging: false
  })),

  on(otpRequired, state => ({
    ...state,
    otpRequired: true
  })),

  on(verifyOtp, state => ({
    ...state,
    error: '',
    isLogging: true
  })),

  on(verifyOtpSuccess, (state, { accessToken, userInfo }) => ({
    ...state,
    accessToken,
    userInfo,
    isLogging: false,
    isLoggedIn: true
  })),

  on(verifyOtpFailed, (state, { error }) => ({
    ...state,
    error,
    isLogging: false
  })),

  on(register, state => ({
    ...state,
    isRegistering: true
  })),

  on(registerSuccess, state => ({
    ...state,
    isRegistering: false
  })),

  on(registerFailed, (state, { error }) => ({
    ...state,
    error,
    isRegistering: false
  })),

  on(setAuthState, (state, { userInfo, accessToken }) => ({ ...state, userInfo, isLoggedIn: true, accessToken })),

  on(updateUserInfoField, (state, { field, value }) => ({
    ...state,
    userInfo: {
      ...state.userInfo!,
      [field]: value
    }
  })),

  on(logout, state => ({
    ...state,
    isLoggedIn: false,
    otpRequired: false,
    userInfo: undefined
  })),

  on(setFacebookAccounts, (state, { facebookAccounts }) => {
    const fbAccountSelected = JSON.parse(localStorage.getItem('fbAccount') || '{}');
    const curAccount = facebookAccounts.find(acc => acc.id == fbAccountSelected);

    return {
      ...state,
      facebookAccounts: facebookAccounts,
      facebookAccountSelected: curAccount || facebookAccounts[0]
    };
  }),

  on(setFacebookAccountSelected, (state, { facebookAccount }) => ({
    ...state,
    facebookAccountSelected: facebookAccount
  })),

  on(setBusinessIdSelected, (state, { id }) => ({
    ...state,
    businessIdSelected: id
  })),

  on(setBusinessNameSelected, (state, { name }) => ({
    ...state,
    businessNameSelected: name
  }))
);
